import React from 'react'
import './index.scss'

const MemberBenefits = () => (
    <div>
        <h2>Member Benefits</h2>
        <iframe
            name="Member_Benefits Search and Report"
            title="Member_Benefits Search and Report"
            src="https://c0hce805.caspio.com/dp/4525a000b105ab3e27e64f9e9d90"
            className="member-benefits-iframe"
        >
            Sorry, but your browser does not support frames.
        </iframe>
    </div>
)

export default MemberBenefits
